import React, { useState } from 'react'
import ModalComponent2 from '../../Modals/ModalComponent2'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { getErrorMessageFromApiResponse } from '../../../utils/api/apiUtils'
import { t } from 'i18next'
import { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider'

const CreateSubsequentDeliveryModal = ({ handleClose, receiptId }) => {
const {
    setSubsequentDeliveryResult
    } = useLocalReceiptDataState()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const createSubsequentDelivery = async () => {
    try {
        setLoading(true)
        let result = await apiClient.postJson(APIEndpoints.localGoodsReceipts(receiptId).subsequentDelivery, {})
        setSubsequentDeliveryResult(result)
        handleClose()
    }
    catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    }
    finally {
      setLoading(false)
    }
  }

  return (
    <ModalComponent2
      ModalTitle={t('createSubsequentDelivery:title')}
      button1Function={createSubsequentDelivery}
      button1Text={t('yes')}
      button2Function={handleClose}
      button2Text={t('no')}
      button1Loading={loading}
      BodyPart1={t('createSubsequentDelivery:bodyText')}
      functionCancel={handleClose}
      showButton2={true}
      withoutCloseButton={true}
      error={error}
      centered
    >
    </ModalComponent2 >
  )
}

export default CreateSubsequentDeliveryModal